import React, { useEffect, useState, useRef } from "react";
import { api } from "../../../services/api";
import { formatInTimeZone } from "date-fns-tz";
import "./cardaniversario.css";
import Foto from "../Foto";

const DEFAULT_USER =
  "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg";

const cacheKey = (chapa) => `foto_${String(chapa)}`;
const getCachedPhoto = (chapa) => localStorage.getItem(cacheKey(chapa));
const setCachedPhoto = (chapa, dataUrl) => {
  try {
    localStorage.setItem(cacheKey(chapa), dataUrl);
  } catch {}
};

async function refreshPhoto(chapa, onChange) {
  try {
    const res = await api.get(`/usuario/foto/${chapa}`);
    if (res?.data?.foto) {
      const newUrl = `data:image/jpeg;base64,${res.data.foto}`;
      const oldUrl = getCachedPhoto(chapa);
      if (newUrl !== oldUrl) {
        setCachedPhoto(chapa, newUrl);
        if (typeof onChange === "function") onChange(newUrl);
      }
    }
  } catch {}
}

function BirthdayCarousel() {
  const [aniversariantes, setAniversariantes] = useState([]);
  const [fotosMap, setFotosMap] = useState({});
  const [fotoSelecionada, setFotoSelecionada] = useState(null);
  const [chapaUsuarioLogado, setChapaUsuarioLogado] = useState(null);

  const scrollAnimationRef = useRef(null);
  const isInteractingRef = useRef(false);
  const interactionTimeoutRef = useRef(null);

  // 🔥 NOVO
  const trackRef = useRef(null);
  const positionRef = useRef(0);

  const startAutoScroll = () => {
    if (aniversariantes.length <= 1) return;

    stopAutoScroll();

    const step = () => {
      if (isInteractingRef.current) {
        scrollAnimationRef.current = requestAnimationFrame(step);
        return;
      }

      positionRef.current += 0.5;

      const track = trackRef.current;
      if (!track) return;

      const totalWidth = track.scrollWidth / 2;

      if (positionRef.current >= totalWidth) {
        positionRef.current = 0;
      }

      track.style.transform = `translateX(-${positionRef.current}px)`;

      scrollAnimationRef.current = requestAnimationFrame(step);
    };

    scrollAnimationRef.current = requestAnimationFrame(step);
  };

  const stopAutoScroll = () => {
    if (scrollAnimationRef.current) {
      cancelAnimationFrame(scrollAnimationRef.current);
      scrollAnimationRef.current = null;
    }
  };

  const handleManualScroll = () => {
    isInteractingRef.current = true;

    if (interactionTimeoutRef.current) {
      clearTimeout(interactionTimeoutRef.current);
    }

    interactionTimeoutRef.current = setTimeout(() => {
      isInteractingRef.current = false;
    }, 8000);
  };

  useEffect(() => {
    setChapaUsuarioLogado(localStorage.getItem("chapa"));

    const loadAniversariantes = async () => {
      try {
        const res = await api.get("/usuario/aniversario");
        const data = res?.data || [];
        setAniversariantes(data);

        const initialFotos = {};
        data.forEach((a) => {
          const chapa = String(a.chapa);
          initialFotos[chapa] = getCachedPhoto(chapa) || DEFAULT_USER;
        });
        setFotosMap(initialFotos);

        data.forEach((a) => {
          const chapa = String(a.chapa);
          refreshPhoto(chapa, (newUrl) => {
            setFotosMap((prev) => ({ ...prev, [chapa]: newUrl }));
          });
        });
      } catch (e) {
        console.error("Erro ao carregar aniversariantes", e);
      }
    };

    loadAniversariantes();
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (aniversariantes.length > 0) startAutoScroll();
    }, 1000);

    return () => {
      stopAutoScroll();
      clearTimeout(timeoutId);
      if (interactionTimeoutRef.current)
        clearTimeout(interactionTimeoutRef.current);
    };
  }, [aniversariantes]);

  const openFoto = (fotoUrl, nome, loja) => {
    if (!fotoUrl || fotoUrl === DEFAULT_USER) return;
    setFotoSelecionada({ foto: fotoUrl, nome, loja });
  };

  if (aniversariantes.length === 0) return null;

  return (
    <div
      className="aniversario-carrossel"
      onMouseEnter={() => (isInteractingRef.current = true)}
      onMouseLeave={() => (isInteractingRef.current = false)}
      onWheel={handleManualScroll}
      onTouchStart={() => (isInteractingRef.current = true)}
      onTouchEnd={handleManualScroll}
    >
      <div className="aniversario-list" ref={trackRef}>
        {[...aniversariantes, ...aniversariantes].map((pessoa, idx) => {
          const chapa = String(pessoa.chapa);
          const isAnonimo = pessoa.exibir !== "S";
          const fotoUrl = isAnonimo
            ? DEFAULT_USER
            : fotosMap[chapa] || DEFAULT_USER;
          const isUserBirthday = chapa === chapaUsuarioLogado;

          return (
            <div
              key={idx}
              className={`aniversario-card text-center ${
                isUserBirthday ? "birthday-highlight" : ""
              }`}
            >
              <h6 className="mb-1">
                {pessoa.nomefilial || "Loja não informada"}
              </h6>

              <img
                src={fotoUrl}
                alt={isAnonimo ? "Anônimo" : pessoa.nome}
                className="aniversario-foto"
                onClick={() =>
                  openFoto(fotoUrl, pessoa.nome, pessoa.nomefilial)
                }
                style={{
                  cursor:
                    fotoUrl !== DEFAULT_USER ? "zoom-in" : "default",
                }}
              />

              <h5 className="mt-2">
                {isAnonimo ? "Preferiu o anonimato" : pessoa.nome}
              </h5>

              <small>
                🎂{" "}
                {formatInTimeZone(
                  pessoa.dtnascimento?.substring(0, 23),
                  "America/Sao_Paulo",
                  "dd'/'MM'"
                )}
              </small>

              {isUserBirthday && (
                <div className="parabens-message">
                  🎉 Parabéns para você! 🎉
                </div>
              )}
            </div>
          );
        })}
      </div>

      <Foto
        show={!!fotoSelecionada}
        onClose={() => setFotoSelecionada(null)}
        foto={fotoSelecionada?.foto}
        nome={fotoSelecionada?.nome}
        info01={fotoSelecionada?.loja}
        info02=""
      />
    </div>
  );
}

export default BirthdayCarousel;